import React, { useEffect, useState } from "react";
import { Button, Checkbox, Form, Input, Row, Col, Space, Modal } from "antd";
import { Link, useHistory, Redirect } from "react-router-dom";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import LockOutlined from "@ant-design/icons/lib/icons/LockOutlined";
import KeyOutlined from "@ant-design/icons/lib/icons/KeyOutlined";
import ReCAPTCHA from "react-google-recaptcha";

import {
  GenerateAuthenticationCode,
  DecodeAuthenticationCode,
} from "../../../util/Authenticate";
import { SetWithExpiry } from "../../../util/sessionManager";
import { Login } from "../../../API/Authentication";

const ErrorModal = Modal.error;
const WarningModal = Modal.warning;

const FormItem = Form.Item;

export default function SignUp() {
  const [loadingButton, setLoadingButton] = useState({ loading: false });
  const [parameter1, setParameter1] = useState(GenerateAuthenticationCode());
  const [SP, setSP] = useState({});
  const history = useHistory();

  useEffect(() => {
    import("./index.css");
  }, []);

  const onFinishFailed = (errorInfo) => {};

  const onFinish = (values) => {
    setLoadingButton({ loading: true });
    try {
      const SP = DecodeAuthenticationCode(parameter1, values.parameter2);
      if (SP) {
        localStorage.setItem("serial_program", SP);
        localStorage.setItem("privilage",JSON.stringify({
          fee1: true,
          fee2: true,
          fee3: true,
          fee4: true,
          price5: true,
          content: true,
          pac: true,
          pac2: true,
          count: true,
        }));
        history.push("authenticate/signin");
      } else {
        WarningModal({
          title: "هشدار",
          content: "پارامتر ورودی اشتباه می باشد",
          okText: "باشد",
          okType: "danger",
          onOk() {},
        });
      }
    } catch (e) {
      ErrorModal({
        title: "خطا",
        content: "مشکلی هنگان انجام عمیلات رخداد",
        okText: "باشد",
        okType: "danger",
        onOk() {},
      });
    }
    setLoadingButton({ loading: false });
  };

  return (
    <Row className="loginPage">
      <Col lg={12} md={24} sm={24} className="loginPageRight">
        <div className="gx-login-container">
          <div className="gx-login-content">
            <div className="gx-login-header">
              <span className="gx-login-title">احراز هویت</span>
            </div>
            <Form
              initialValues={{ remember: true }}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="gx-signin-form gx-form-row0"
            >
              <FormItem label="پارامتر اول" name="parameter1">
                <Input
                  disabled
                  prefix={
                    <KeyOutlined
                      style={{ color: "rgba(0,0,0,.25)" }}
                      className="gx-w-100"
                    />
                  }
                  defaultValue={parameter1}
                  value={parameter1}
                />
              </FormItem>
              <FormItem
                label="پارامتر دوم"
                rules={[
                  { required: true, message: "لطفا پارامتر دوم رو وارد کن!" },
                ]}
                name="parameter2"
              >
                <Input
                  prefix={
                    <KeyOutlined
                      style={{ color: "rgba(0,0,0,.25)" }}
                      className="gx-w-100"
                    />
                  }
                />
              </FormItem>
              <FormItem className="gx-text-right loginButton">
                <Button type="primary" htmlType="submit" {...loadingButton}>
                  ورود
                </Button>
              </FormItem>
            </Form>
          </div>
          <Row className="loginLogo">
            <img src={"https://www.sabaapi.com/webapi/visitor/frontEnd/logowhite.png"} />
          </Row>
        </div>
      </Col>
      <Col lg={12} md={0} sm={0} className="loginPageLeft"></Col>
    </Row>
  );
}
